/**
 * Debug Badge Component
 *
 * A small 🐞 indicator that appears next to story/show names
 * when usedDebug=true, indicating the content was generated
 * using debug model presets.
 *
 * @module DebugBadge
 */

import { Tooltip, Box } from '@mui/material';
import { Bug } from 'lucide-react';

interface DebugBadgeProps {
  /** Whether to show the badge */
  show?: boolean;
  /** Size of the bug icon */
  size?: number;
  /** Whether to show tooltip */
  showTooltip?: boolean;
}

/**
 * DebugBadge - Visual indicator for content generated with debug presets
 */
export function DebugBadge({
  show = false,
  size = 16,
  showTooltip = true,
}: DebugBadgeProps) {
  if (!show) {
    return null;
  }

  const badge = (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ml: 0.5,
        color: '#f44336',
      }}
    >
      <Bug size={size} />
    </Box>
  );

  if (!showTooltip) {
    return badge;
  }

  return <Tooltip title="Generated with debug model preset">{badge}</Tooltip>;
}
